import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { api } from '../../lib/api';
import { Input } from '../../components/ui/input';
import { Button } from '../../components/ui/button';
import { Search } from 'lucide-react';
import { useLanguage } from '../../lib/LanguageContext';

const statusBg = { en_attente: 'bg-amber-100 text-amber-800', actif: 'bg-emerald-100 text-emerald-800', inactif: 'bg-slate-100 text-slate-700', bloque: 'bg-rose-100 text-rose-700' };
const clientStatus = { standard: 'bg-slate-100 text-slate-700', premium: 'bg-blue-100 text-blue-700', gold: 'bg-amber-100 text-amber-700', diamond: 'bg-purple-100 text-purple-700' };

export default function AdminClients() {
  const { t } = useLanguage();
  const statusLabel = { en_attente: t('admin.pending'), actif: t('card.status.active'), inactif: t('card.status.inactive'), bloque: t('card.status.blocked') };
  const [items, setItems] = useState([]);
  const [q, setQ] = useState('');
  const load = async () => {
    const params = q ? { q } : {};
    const r = await api.get('/admin/clients', { params });
    setItems(r.data);
  };
  useEffect(() => { load(); /* eslint-disable-next-line */ }, []);
  return (
    <div className="space-y-5">
      <h1 className="text-2xl font-bold">{t('admin.clientsTitle')}</h1>
      <div className="flex gap-2 max-w-md">
        <Input placeholder={t('admin.searchClient')} value={q} onChange={(e) => setQ(e.target.value)} onKeyDown={(e) => e.key === 'Enter' && load()} data-testid="input-clients-search"/>
        <Button onClick={load} className="bg-blue-700" data-testid="btn-clients-search"><Search className="w-4 h-4"/></Button>
      </div>
      <div className="bg-white rounded-2xl border overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="bg-slate-50 text-slate-600 text-xs uppercase">
              <tr><th className="text-left p-3">{t('admin.nav.clients')}</th><th className="text-left p-3">{t('common.email')}</th><th className="text-right p-3">{t('rib.balance')}</th><th className="p-3">{t('common.status')}</th><th className="p-3">{t('common.type')}</th><th className="text-right p-3">{t('admin.lastInscriptions')}</th><th></th></tr>
            </thead>
            <tbody className="divide-y">
              {items.map((u) => (
                <tr key={u.id} className="hover:bg-slate-50">
                  <td className="p-3 font-medium">{u.prenom} {u.nom}</td>
                  <td className="p-3 text-slate-600">{u.email}</td>
                  <td className="p-3 text-right font-semibold">{(u.solde || 0).toLocaleString('fr-FR', { minimumFractionDigits: 2 })} €</td>
                  <td className="p-3 text-center"><span className={`text-xs px-2 py-1 rounded font-medium ${statusBg[u.statut_compte] || ''}`}>{statusLabel[u.statut_compte] || u.statut_compte}</span></td>
                  <td className="p-3 text-center"><span className={`text-xs px-2 py-1 rounded font-medium capitalize ${clientStatus[u.statut_client] || ''}`}>{u.statut_client || 'standard'}</span></td>
                  <td className="p-3 text-right text-xs text-slate-500">{u.created_at ? new Date(u.created_at).toLocaleDateString('fr-FR') : '—'}</td>
                  <td className="p-3 text-right"><Link to={`/admin/clients/${u.id}`}><Button size="sm" variant="outline" data-testid={`btn-view-client-${u.id}`}>{t('common.view')}</Button></Link></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        {items.length === 0 && <div className="p-8 text-center text-slate-500 text-sm">{t('common.noResults')}</div>}
      </div>
    </div>
  );
}
